<template>
  <div class="filters" :class="{ active: show }">
    <div class="scroll-zone" ref="scrollzone">
      <div class="flex-between">
        <h4 class="label">Project Filters</h4>
        <a class="close" @click="close()"
          ><i class="material-icons">clear</i></a
        >
      </div>

      <label>Stakeholders</label>
      <multi-select
        type="teamMembers"
        :values="project_filters.teamMembers"
        :onChange="handleChange"
        label="stakeholder"
        labelPlural="stakeholders"
        includeSearch
      />

      <label>Statuses</label>
      <multi-select
        type="status"
        :values="project_filters.status"
        :onChange="handleChange"
        label="status"
        labelPlural="statuses"
      />

      <label>Date range</label>
      <datepicker
        :value="selectedDates"
        mode="range"
        :onChange="handleDateChange"
      />

      <label>Types</label>
      <multi-select
        type="type"
        :values="project_filters.type"
        :onChange="handleChange"
        label="type"
        labelPlural="types"
      />

      <label>Teams</label>
      <multi-select
        type="categoryId"
        :values="project_filters.categoryId"
        :onChange="handleChange"
        label="team"
        labelPlural="teams"
      />
    </div>

    <div class="apply-filters">
      <a class="button" @click="applyFilters()">Apply</a>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from './Datepicker';
import MultiSelect from './MultiSelect';

export default {
  name: 'ProjectFilters',
  data() {
    return {
      project_filters: JSON.parse(
        JSON.stringify(this.$store.getters.project_filters)
      ),
    };
  },
  props: {
    onApply: Function,
  },
  components: {
    'multi-select': MultiSelect,
    datepicker: Datepicker,
  },
  methods: {
    handleDateChange(dates) {
      if (!dates) {
        this.project_filters.dates = { start: null, end: null };
        return;
      }

      const arr = dates.split(' to ');

      if (arr && arr.length === 2) {
        this.project_filters.dates = {
          start: moment(arr[0], 'D MMM YYYY').toISOString(),
          end: moment(arr[1], 'D MMM YYYY').toISOString(),
        };
      }
    },
    handleChange(val, kind) {
      if (val === 'All') {
        this.project_filters[kind] = ['All'];
        return;
      }

      // they've picked something other than All, so filter All out
      this.project_filters[kind] = this.project_filters[kind].filter(
        s => s !== 'All'
      );

      // if they've picked something we already have, deselect it
      if (this.project_filters[kind].includes(val)) {
        this.project_filters[kind] = this.project_filters[kind].filter(
          s => s !== val
        );

        if (!this.project_filters[kind].length) {
          this.project_filters[kind] = ['All'];
        }

        return;
      }

      this.project_filters[kind].push(val);
    },
    applyFilters() {
      this.$store.dispatch('setPage', 1);
      this.$store.dispatch('setProjectFilters', this.project_filters);

      this.onApply();
      this.close();
    },
    close() {
      this.$store.dispatch('setProjectFiltersVisible', false);
    },
    reset() {
      this.$store.dispatch('resetProjectFilters');
    },
  },
  computed: {
    show() {
      return this.$store.getters.project_filters_visible;
    },
    stored_filters() {
      return JSON.parse(JSON.stringify(this.$store.getters.project_filters));
    },
    filtered_start_date() {
      if (
        !this.project_filters ||
        !this.project_filters.dates ||
        !this.project_filters.dates.start
      )
        return '';
      return this.project_filters.dates.start;
    },
    filtered_end_date() {
      if (
        !this.project_filters ||
        !this.project_filters.dates ||
        !this.project_filters.dates.end
      )
        return '';
      return this.project_filters.dates.end;
    },
    selectedDates() {
      if (this.filtered_start_date && this.filtered_end_date) {
        const start = moment(this.filtered_start_date).format('D MMM YYYY');
        const end = moment(this.filtered_end_date).format('D MMM YYYY');
        return start + ' to ' + end;
      } else {
        return '';
      }
    },
  },
  watch: {
    show(visible) {
      visible &&
        (this.project_filters = JSON.parse(
          JSON.stringify(this.$store.getters.project_filters)
        ));
      setTimeout(() => {
        if (this && this.$refs && this.$refs.scrollzone && !visible) {
          this.$refs.scrollzone.scrollTo(0, 0);
        }
      }, 1000);
    },
    stored_filters(newValue) {
      this.project_filters = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.filters {
  position: fixed;
  top: 80px;
  right: -380px;
  transition: right 0.6s;
  border-left: 1px solid $border-color;

  height: calc(100% - 80px);
  width: 375px;
  background: #f9fafc;
  pointer-events: none;
  z-index: 800;

  .scroll-zone {
    overflow-y: auto;
    width: 100%;
    height: calc(100% - 100px);
    padding: 37px 25px;
  }

  &.active {
    right: 0;
    pointer-events: auto;
  }

  h4 {
    margin: 0;
    user-select: none;
  }

  .close {
    cursor: pointer;
    user-select: none;
    height: 24px;
    position: relative;
    right: -2px;
  }

  label {
    color: #26292f;
    font-size: 16px;
    font-weight: 500;
    margin-top: 40px;
    display: block;
  }

  ::v-deep .c-day-popover .popover-origin {
    display: none !important;
  }
}

.apply-filters {
  border-top: 1px solid #dbdee5;
  padding: 25px 0;
  margin: 0 25px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 50px);

  .button {
    width: 140px;
    min-width: 140px;
    margin: 0;
  }
}

.datepicker {
  width: 100%;

  ::v-deep .datepicker-input {
    width: 100%;
  }
}
</style>
